import { Stage } from "src/generated/graphqlTypes";
import { BudgetPage } from "src/routes/projects/budget/BudgetPage";
import { HierarchyBudgetPage } from "src/routes/projects/budget/HierarchyBudgetPage";
import { useProjectContext } from "src/routes/projects/context/ProjectContext";
import { RedirectToProjectDashboard } from "src/routes/projects/projectRouteRedirects";
import { SpecsAndSelectionsPage } from "src/routes/projects/selections/SpecsAndSelectionsPage";

/** Budget leaf: gate on canHaveBudget, then pick standalone vs hierarchy page. */
export function ProjectBudgetPage() {
  const { __typename, canHaveBudget } = useProjectContext();
  if (!canHaveBudget) {
    return <RedirectToProjectDashboard />;
  }
  if (__typename === "StandaloneProject") {
    return <BudgetPage />;
  }
  return <HierarchyBudgetPage />;
}

export function PreConServicesPage() {
  return <SpecsAndSelectionsPage stage={Stage.PreConExecution} />;
}

export function ConstructionSpecsAndSelectionsPage() {
  return <SpecsAndSelectionsPage stage={Stage.Construction} />;
}
